import { createFileRoute } from '@tanstack/react-router'
import { AdminDeliveryZones } from '@/components/admin/AdminDeliveryZones'
import {
  OnlineOrderingGateSkeleton,
  OnlineOrderingPaywall,
} from '@/components/admin/OnlineOrderingPaywall'
import { useOnlineOrderingEnabled } from '@/hooks/useOnlineOrderingEnabled'

// Delivery zones only affect the online-ordering storefront, so they sit
// behind the same premium gate as the Online Orders inbox (route-level, like
// /admin/online-orders — the editor and its Maps script never load on locked
// tenants).
function DeliveryZonesRoute() {
  const { enabled, isLoading, isError } = useOnlineOrderingEnabled()
  if (isError)
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
        <p className="text-sm text-muted-foreground">
          Couldn’t load settings. Check your connection and try again.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md border px-4 py-2 text-sm font-medium hover:bg-muted"
        >
          Retry
        </button>
      </div>
    )
  if (isLoading) return <OnlineOrderingGateSkeleton />
  if (!enabled) return <OnlineOrderingPaywall />
  return <AdminDeliveryZones />
}

export const Route = createFileRoute('/admin/delivery-zones')({
  component: DeliveryZonesRoute,
})
